export const getS3Url = (path) => {
  const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;
  const url = `https://s3.ap-south-1.amazonaws.com/${bucketName}/${path}`;
  return url;
};
